import {
  SEND_SECURE_PIN_TO_DEVICE_BEGIN,
  SEND_SECURE_PIN_TO_DEVICE_SUCCESS,
  SEND_SECURE_PIN_TO_DEVICE_FAILURE,
  VALIDATE_SECURE_PIN_BEGIN,
  VALIDATE_SECURE_PIN_SUCCESS,
  VALIDATE_SECURE_PIN_FAILURE,
  GENERIC_ERROR_MESSAGE
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";
import { checkAMLob } from "utils/checkAMLob";
import { isUnregistered } from "utils/isUnregistered";

import { encryptData } from "utils/decryptData";

export const sendSecurePinToDevice = () => async (dispatch, getState) => {
  dispatch({ type: SEND_SECURE_PIN_TO_DEVICE_BEGIN });

  const { sendPinToEmail, encryptedEmail, encryptedMdn } = getState().verifiedSecurePinDevice;
  const { emailId } = getState().downloadAndDelete;

  let data = null;
  let url = "";

  if (isUnregistered()) {
    url = ENDPOINTS.GUEST_FLOW_MFA_REQUEST_PIN;
    data = { emailId };
  } else {
    if (checkAMLob() === "vzt") {
      url = ENDPOINTS.SEND_SECURE_PIN_WIRELINE;
    } else if (checkAMLob() === "ott") {
      url = ENDPOINTS.SEND_SECURE_PIN_OTT;
    } else if(checkAMLob() === "autoapp"){
      url = ENDPOINTS.SEND_SECURE_PIN_CVA;    //developer Arvind
    } else if(checkAMLob() === "ip"){
      url = ENDPOINTS.SEND_SECURE_PIN_FAMILY_APP;   //developer Arvind
    } else if (checkAMLob() === "nico") {
      url = ENDPOINTS.SEND_SECURE_PIN_FAMILY_MONEY;
    } else if (checkAMLob() === "vils") {
      url = ENDPOINTS.SEND_SECURE_PIN_VILS;
    } else {
      url = ENDPOINTS.SEND_SECURE_PIN_TO_DEVICE;
      data = sendPinToEmail ? { encryptedEmail } : { encryptedMdn };
    }
  }

  try {
    const response = await API({
      method: "POST",
      url,
      data,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=UTF-8"
      }
    });

    if (response && response.data && parseInt(response.data.status) === 1) {
      dispatch({
        type: SEND_SECURE_PIN_TO_DEVICE_SUCCESS
      });
    } else {
      dispatch({
        type: SEND_SECURE_PIN_TO_DEVICE_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  } catch (error) {
    dispatch({
      type: SEND_SECURE_PIN_TO_DEVICE_FAILURE,
      payload: error.response.description || GENERIC_ERROR_MESSAGE
    });
  }
};

export const validateSecurePin = pin => async dispatch => {
  dispatch({ type: VALIDATE_SECURE_PIN_BEGIN });

  try {
    const response = await API({
      method: "POST",
      url: isUnregistered() ? ENDPOINTS.GUEST_FLOW_MFA_VALIDATE_PIN : ENDPOINTS.VALIDATE_SECURE_PIN,
      data: { securePIN: encryptData(pin) },
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=UTF-8"
      }
    });

    if (response && response.data && parseInt(response.data.status) === 1) {
      
      const payload = {
        ...response.data
      };
      //CXTDT-665511 developer Arvind
      if (response && response.data && parseInt(response.data.status) === 1 && response.data.emailAddress) { 
        var emailData = response.data.emailAddress ? response.data.emailAddress.split("@").pop() : ""
        payload.byPassEmail = emailData
      }
      dispatch({
        type: VALIDATE_SECURE_PIN_SUCCESS,
        payload
      });
    } else {
      dispatch({
        type: VALIDATE_SECURE_PIN_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  } catch (error) {
    dispatch({
      type: VALIDATE_SECURE_PIN_FAILURE,
      payload: error.response.description || GENERIC_ERROR_MESSAGE
    });
  }
};
